import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeSessionImageReport } from './Pages';

export const EmployeeSessionImageReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeSessionImageReport} />
    </Fragment>
)